import { Table } from '@tanstack/react-table';
import { Input } from '@repo/ui';
import SearchIcon from '@repo/ui/components/icons/Search';
import UnderlineHeading from '@repo/ui/components/heading/UnderlineHeading';
import usePermissions from '@repo/hooks/usePermissions';
import PatientExportButton from './patientExportButton';
import { addPatient } from '../../types/patient.types';
import { Filters } from '@/types/table.types';

interface DataTableToolbarProps {
    table: Table<addPatient>;
    globalFilter: string;
    setGlobalFilter: (value: string) => void;
    filters: Filters;
    setFilters: (value: Filters) => void;
    setFilterStatus: (status: string) => void;
    onApplyFilter: () => void;
    data: addPatient[];
    handleRefreshTable: () => void;
}

export function DataTableToolbar({
    table,
    globalFilter,
    setGlobalFilter,
    filters,
    setFilters,
    setFilterStatus,
    onApplyFilter,
    data,
    handleRefreshTable,
}: DataTableToolbarProps) {
    const permissions = usePermissions();
    const canList = permissions.includes('list_report');

    return (
        <div className="flex flex-col p-2 sm:flex-row sm:items-center sm:justify-between">
            <UnderlineHeading text="قائمة المرضى" />
            <div className="flex flex-row items-center gap-4">
                <div className="flex flex-row items-center w-[287px] border border-white-blue-300 bg-white-blue-50 h-[36px] p-2 rounded-[6px]">
                    <Input
                        placeholder="ابحث باسم المريض"
                        value={globalFilter}
                        onChange={(event) => {
                            setGlobalFilter(event.target.value);
                        }}
                        className="text-white-blue-800 p-0 tracking-normal text-xs lg:text-sm lg:leading-[16.8px] border-none outline-none focus-visible:ring-0 placeholder:text-white-blue-800"
                    />
                    <button className="bg-transparent border-none">
                        <SearchIcon className="text-white-blue-800" />
                    </button>
                </div>
                <div className="flex flex-row items-center gap-4">
                    <select
                        value={(filters?.status as string) || ''}
                        onChange={(event) => {
                            const value = event.target.value;
                            setFilters({ ...filters, status: value });
                            setFilterStatus(value);
                            onApplyFilter();
                        }}
                        className="min-w-[77px] text-xs text-white-blue-800 bg-white-blue-50 border border-white-blue-300 rounded-[6px] p-2 focus:outline-none"
                    >
                        <option value="">الكل</option>
                        <option value="new">جديد</option>
                        <option value="blocked">محظور</option>
                        <option value="special">special</option>
                    </select>
                </div>
                {canList && <PatientExportButton table={table} />}
            </div>
        </div>
    );
}
